export default __webpack_public_path__ + "static/media/PEDESTRE.6e935a86.svg";